import { toast } from "sonner";
import { useSecrets } from "@/context/SecretsContext";
import { PUZZLE } from "@/data/secrets";

/**
 * Wraps any element and turns it into a recoverable fragment. Keyboard
 * accessible; gives itself away only through the cursor.
 */
export const FragmentProbe = ({
  fragmentId,
  children,
  className = "",
  as: As = "span",
  label
}) => {
  const { foundFragment, hasFragment, unlocked } = useSecrets();
  const index = PUZZLE.fragments.findIndex((f) => f.id === fragmentId);
  const fragment = PUZZLE.fragments[index];
  const found = hasFragment(fragmentId);

  const probe = () => {
    if (unlocked) return;
    const isNew = foundFragment(fragmentId);
    if (isNew && fragment) {
      toast(`Fragment ${index + 1} of ${PUZZLE.fragments.length} recovered`, {
        description: `${fragment.value} — ${fragment.note}`
      });
    }
  };

  return (
    <As
      role="button"
      tabIndex={0}
      aria-label={label || "Probe this record"}
      onClick={probe}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          probe();
        }
      }}
      data-testid={`fragment-probe-${fragmentId}`}
      className={`cursor-crosshair outline-none transition-colors duration-150 ${
        found ? "text-[hsl(174_62%_64%)]" : ""
      } ${className}`}
    >
      {children}
      {found && (
        <span className="ml-1.5 font-mono text-[10px] tracking-[0.14em] text-[hsl(174_62%_60%)]">
          [{fragment?.value}]
        </span>
      )}
    </As>
  );
};
